export const locale = {
    lang: 'pt',
    data: {
        CLINIC_MESSAGE_NOTIFICATION: {
            DATE_FORMAT: 'dd/MM/yyyy',
            EMPTY: 'Você não possui mensagens',
            EMPTY_PATIENT: 'Paciente não definido',
            VIEW_ALL: 'Ver todas',
            VIEW_UNREAD: 'Ver não lidas',
            MAKE_AS_READ: 'Marcar como lidas',
            GO_TO_MESSAGE: 'Ir para o chat do cliente',
            GO_TO_CHAT: 'Ir para o chat',
            REMAKE_TYPE: {
                REMAKE: 'Repetição',
                REMAKE_INITIAL: 'R',
                ADJUSTMENT: 'Ajuste',
                ADJUSTMENT_INITIAL: 'A',
            },
        },
    },
};
